import { useState } from "react";

import useDiscountFormStore from "@/stores/useDiscountFormStore";

const useSaveDiscount = ({ isEditMode, discountId }) => {
  const { setIsSaving, setError } = useDiscountFormStore();

  const saveDiscount = async (data) => {
    setIsSaving(true);
    setError(null);

    try {
      const endpoint = isEditMode
        ? `/api/discounts/${discountId}`
        : `/api/discounts`;
      const method = isEditMode ? "PATCH" : "POST";

      const res = await fetch(endpoint, {
        method,
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      if (!res.ok) throw new Error("Failed to save discount");

      const result = await res.json();
      return result;
    } catch (err) {
      setError(err.message || "Unknown error");
      throw err;
    } finally {
      setIsSaving(false);
    }
  };

  return {
    saveDiscount,
  };
};

export default useSaveDiscount;